import React, { useState } from "react";
import { BiCheck, BiCross, BiX } from "react-icons/bi";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
} from "reactstrap";

export default function AnswerFeedbackComponent({
  handleAnswerFailure,
  answer,
  question,
  showNotifyOptions,
  triggerInput,
}) {
  const [showSendOptions, setShowSendOptions] = useState(false);
  return (
    <span className="mt-2">
      <div className="dani-step p-1">
        Would you like to Notify an Advisor? if not, just ask another question
        if you would like.
      </div>
      {showNotifyOptions && (
        <ul
          className="dani-option-ul"
          style={{
            margin: "0 0 5px 0",
            paddingLeft: "48px",
            listStyle: "none",
            paddingInlineStart: "0px",
          }}
        >
          <li
            className="dani-option-item"
            onClick={() =>
              handleAnswerFailure({
                question,
                answer,
                anonymous: false,
              })
            }
          >
            <span className="dani-option-element">Notify Advisor</span>
          </li>
          <li
            className="dani-option-item"
            onClick={() =>
              handleAnswerFailure({
                question,
                answer,
                anonymous: true,
              })
            }
          >
            <span className="dani-option-element">
              Notify Advisor Anonymously
            </span>
          </li>
          {/*<li className="dani-option-item" onClick={() => triggerInput()}>
            <span className="dani-option-element">Dont Notify</span>
          </li>*/}
        </ul>
      )}
    </span>
  );
}
